import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MAINTENANCE_WEEKDAYS } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';

export function useMaintenanceWeekdayOptions() {
  const { t } = useTranslation('sla');

  return useMemo(
    () =>
      MAINTENANCE_WEEKDAYS.map((day) => ({
        label: t(`oems.maintenance.days.${day}`),
        value: day,
      })),
    [t],
  );
}
